import listViewStore from '../store/Store';
import { getRowIdString } from '../selectors/mailRowDataPropertyGetter';
/**
 * Returns a collection of the rowIdStrings for the given rowKeys
 * @param rowKeys rowKeys to get rowIds for
 * @param tableView tableView to loop up
 */
export default function getRowIdsFromRowKeys(rowKeys, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var rowIdStrings = [];
    rowKeys.forEach(function (rowKey) {
        // In case of multi-value sorts there can be two rows with same conversation/item
        // Hence we have to dedup the ids
        var rowId = getRowIdString(rowKey, tableView);
        if (rowIdStrings.indexOf(rowId) == -1) {
            rowIdStrings.push(rowId);
        }
    });
    return rowIdStrings;
}
//# sourceMappingURL=getRowIdsFromRowKeys.js.map